/* The pilot leaves Dawn product-info, variant prices and purchase forms intact. */
if (!customElements.get('diana-pdp-gallery')) {
  customElements.define('diana-pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.panels = [...this.querySelectorAll('[data-pdp-panel]')];
      this.thumbs = [...this.querySelectorAll('[data-pdp-thumb]')];
      this.dialog = this.querySelector('dialog');
      if (!this.panels.length || this.panels.length !== this.thumbs.length) return;
      this.ready = true;
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', event => { event.preventDefault(); this.select(index);
          // Full-width portrait films are taller than images. Reveal the media,
          // not the thumbnail retained by the browser's scroll anchoring.
          if (matchMedia('(max-width: 749px)').matches && this.closest('.dl-product-enhanced')) {
            this.panels[index].scrollIntoView({ block: 'start', behavior: 'instant' });
          } });
        thumb.addEventListener('keydown', event => {
          const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: this.thumbs.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.select((next + this.thumbs.length) % this.thumbs.length, true);
        });
      });
      this.querySelectorAll('[data-pdp-zoom]').forEach(trigger => {
        trigger.addEventListener('click', event => {
          if (!this.dialog?.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const source = trigger.querySelector('img');
          this.returnFocus = trigger;
          const enlarged = this.dialog.querySelector('[data-pdp-enlarged]');
          enlarged.src = trigger.href;
          enlarged.alt = source.alt;
          this.dialog.querySelector('[data-pdp-full]').href = trigger.href;
          this.dialog.showModal();
          this.dialog.querySelector('[data-pdp-close]').focus();
        });
      });
      this.dialog?.querySelector('[data-pdp-close]').addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('close', () => this.returnFocus?.focus());
      this.dialog?.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.setAttribute('data-enhanced', '');
      const linked = this.panels.findIndex(panel => `#${panel.id}` === window.location.hash);
      this.select(linked < 0 ? 0 : linked);
    }

    select(index, focus = false) {
      this.panels.forEach((panel, position) => {
        panel.hidden = position !== index;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        if (position === index) this.thumbs[position].setAttribute('aria-current', 'true');
        else this.thumbs[position].removeAttribute('aria-current');
      });
      if (focus) this.thumbs[index].focus({ preventScroll: true });
      if (focus) this.thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
